/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import auth from '../../utils/auth'
import {Route, Redirect} from 'react-router-dom'
import { PATHS } from '../../global/constants'

export default function ProtectedRoute({component: Component, ...rest}) {
    return (
        <Route {...rest} render={
            (props) => {
                if (auth.authenticated) {
                    console.log("shark,authenticated");

                    return <Component {...props} />
                } else {
                    return <Redirect 
                    to = {{
                        pathname: PATHS.login.name,
                        state: {
                            from: props.location
                        }
                    }}
                    />
                }
            }
        }
        />
       
    )
}
